import { League } from "../../../contracts"

/* istanbul ignore next */
export const mapSelected = (leagues: League[], selectedLeagues: string[]): League[] => {
    leagues.forEach((league, i) => {
        const id = selectedLeagues.find(id => league.id === id);
        if (id) {
            league.isSelected = true;
        } else {
            league.isSelected = false;
        }
    });
    return leagues;
}